import { render, staticRenderFns } from "./LbaToolbarButton.vue?vue&type=template&id=5e08bcf4"
import script from "./LbaToolbarButton.vue?vue&type=script&lang=js"
export * from "./LbaToolbarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports